import { NodeModel } from '@minoru/react-dnd-treeview';
import { EmployeeNodeModel } from '../models';

/**
 * Obtenemos un arreglo con los IDs de los empleados que les enviamos
 * @param employees NodeModel[]
 * @returns number[]
 */
export const getEmployeesIds = (employees: EmployeeNodeModel[]) => {

    let filterList= employees.filter(e => e?.documentNumber).map((emp) => Number(emp.id));
   
    return filterList
};
